module.exports = __webpack_public_path__ + "media/src/images/school-6d0685bcaa973650eaff1b0e8bd4036c.png";